import { useContext } from "react";
import useSWRImmutable from "swr/immutable";
import { useServicesContext } from "../../Contexts/ServicesContext/ServicesContext";
import {
  fetchBuilds,
  fetchNews,
  fetchPodcasts,
  fetchTech,
  fetchVideos,
  fetchFeaturedArticle,
  fetchRecommendedArticles,
} from "./contentRequests";
import { UserContext } from "Contexts/UserContext/UserContext";
import { VehicleContext } from "Contexts/VehicleContext";

const buildRecArticleRequest = (userContext, vehicleContext) => {
  return {
    userVin: userContext.userVin(),
    webUserGuid: userContext.userGuid,
    ymmData: {
      year: vehicleContext.selectedVehicle?.yearId,
      make: vehicleContext.selectedVehicle?.makeId,
      model: vehicleContext.selectedVehicle?.modelId,
      raceTypeId: vehicleContext.selectedVehicle?.raceTypeId,
    },
  };
};

const useContent = (shouldFetch) => {
  const services = useServicesContext();
  const { context: userContext } = useContext(UserContext);
  const { context: vehicleContext } = useContext(VehicleContext);
  const contentServiceUrl = services?.content.url;
  const recommendationsServiceUrl = services?.recommendations.url;
  const recArticleRequest = buildRecArticleRequest(userContext, vehicleContext);
  const { data: featuredArticle } = useSWRImmutable(
    shouldFetch ? "getFeaturedArticle" : null,
    () => fetchFeaturedArticle(contentServiceUrl)
  );

  const { data: recommendedArticles } = useSWRImmutable(
    shouldFetch ? ["getRecommendedArticles", recArticleRequest] : null,
    (_, recArticleRequest) =>
      fetchRecommendedArticles(recommendationsServiceUrl, recArticleRequest)
  );

  return {
    featuredArticle,
    recommendedArticles: recommendedArticles,
    tech: fetchTech(),
    builds: fetchBuilds(),
    news: fetchNews(),
    videos: fetchVideos(),
    podcasts: fetchPodcasts(),
  };
};

export default useContent;
